import { render, staticRenderFns } from "./expedientes-new.vue?vue&type=template&id=6596863e&"
import script from "./expedientes-new.vue?vue&type=script&lang=js&"
export * from "./expedientes-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports